/* @flow */

const hexShortHandPattern = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
const hexPattern = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;

export function hex2rgb(hex: string): ?{ r: number, g: number, b: number } {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const value = hex.replace(
    hexShortHandPattern,
    (m, r, g, b) => r + r + g + g + b + b,
  );
  const result = hexPattern.exec(value);

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}
